export default "__VITE_ASSET__90913b41__"